module.exports = __webpack_public_path__ + "media/images/product_owners/peo_isr_sof_90-028ec3361e26765c224dbe6f46ae2b52.png";